import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { InfoCard } from '../dashboard/overview/overview.types';
import { LocationWiseSalesAnalyticsResponse } from './salesPerformance.types';

export type SalesAnalyticsParams = {
  fromDate: number;
  toDate: number;
};

const getSalesPerformanceOverview = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<InfoCard>>('/sales-performance')).data;
};

const getLocationWiseSalesAnalyticsReport = (client: AxiosInstance) => async (params: SalesAnalyticsParams) => {
  return (
    await client.get<ApiResponse<LocationWiseSalesAnalyticsResponse>>('/sales-analytics', {
      params,
    })
  ).data;
};

export const salesPerformanceQueries = {
  all: () => ['sales performance'],
  salesPerformanceOverview: () =>
    queryFactoryOptions<ApiResponse<InfoCard>>({
      queryKey: [...salesPerformanceQueries.all(), 'overview'],
      queryFn: (client) => getSalesPerformanceOverview(client),
    }),
  locationWiseSalesAnalytics: (params: SalesAnalyticsParams) =>
    queryFactoryOptions<ApiResponse<LocationWiseSalesAnalyticsResponse>>({
      queryKey: [...salesPerformanceQueries.all(), 'location wise sales report', params],
      queryFn: (client) => () => getLocationWiseSalesAnalyticsReport(client)(params),
    }),
};
